import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/transfer-queue';

const transferQueueWidgetSuccess = ( props ) => {
    return (
        <div className='ui-transfer-queue'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }

                /**
                 * updateTableOnChange={ true }
                 * the value has been kept true to to update the transfer list, when removed is clicked
                 */
                // updateTableOnChange={ true }
            />
        </div>
    );
};

// set display name
transferQueueWidgetSuccess.displayName = 'transferQueue';

// set default props
transferQueueWidgetSuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
};

// prop types
transferQueueWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
const transferQueueWidgetPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-transfer-queue-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
transferQueueWidgetPreloader.displayName = 'callListWidgetPreloader';

// set default props
transferQueueWidgetPreloader.defaultProps = {};

// prop types
transferQueueWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { transferQueue as TransferQueue } from 'ui/views/widgets/transferQueue';
 *
 * // render
 * <TransferQueue propName='propValue'/>
 */

export const transferQueue = withNetworkState( transferQueueWidgetPreloader, transferQueueWidgetSuccess );
